// Copyright 2025-2026 Florian Gallon. All Rights reserved.
import { useEffect } from 'react';
import { X, Send } from 'lucide-react';

// NOTE: the form still posts to a placeholder Formspree endpoint. Replace
// YOUR_FORM_ID with a real form id (or switch to a mailto: link) before relying
// on this. Wiring it is out of scope for the landing-page redesign.
const FORMSPREE_ACTION = 'https://formspree.io/f/YOUR_FORM_ID';

export default function ContactModal({ isFr, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="dbk-modal"
      role="dialog"
      aria-modal="true"
      aria-label={isFr ? 'Nous contacter' : 'Contact us'}
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="dbk-modal__panel">
        <button
          type="button"
          className="dbk-modal__close"
          onClick={onClose}
          aria-label={isFr ? 'Fermer' : 'Close'}
        >
          <X size={20} strokeWidth={2} />
        </button>

        <h3 className="dbk-h3">{isFr ? 'Nous contacter' : 'Contact us'}</h3>
        <p className="dbk-modal__intro">
          {isFr ? 'Une question ? Envoyez-nous un message.' : 'Have a question? Send us a message.'}
        </p>

        <form action={FORMSPREE_ACTION} method="POST">
          <div className="dbk-field">
            <label htmlFor="dbk-name">{isFr ? 'Nom' : 'Name'}</label>
            <input id="dbk-name" className="dbk-input" type="text" name="name" required />
          </div>
          <div className="dbk-field">
            <label htmlFor="dbk-email">{isFr ? 'E-mail' : 'Email'}</label>
            <input id="dbk-email" className="dbk-input" type="email" name="email" required />
          </div>
          <div className="dbk-field">
            <label htmlFor="dbk-message">Message</label>
            <textarea id="dbk-message" className="dbk-input" name="message" rows={4} required />
          </div>
          <button type="submit" className="dbk-btn dbk-btn--primary dbk-btn--block">
            <Send size={16} strokeWidth={2} />
            {isFr ? 'Envoyer' : 'Send'}
          </button>
        </form>
      </div>
    </div>
  );
}
